import { createModel } from '@rematch/core';
import produce from 'immer';

import { RootModel } from '../models';
import { StoreImageTypes } from '../../types';

export const storeName = 'layoutModel';

type LayoutModelTypes = {
  isMobileDevice: boolean;
  isTabletDevice: boolean;
  orientationAngle: string;
  loading: boolean;
  locale: any;
  isFullscreen: boolean;
  loadingLogo: StoreImageTypes;
  isActivityWindow: boolean;
  chatScriptLoaded: boolean;
  chatVisible: boolean;
  isShowRightPanel: boolean;
};

const initialState: LayoutModelTypes = {
  isMobileDevice: false,
  isTabletDevice: false,
  orientationAngle: null,
  loading: true,
  locale: null,
  isFullscreen: false,
  loadingLogo: null,
  isActivityWindow: true,
  chatScriptLoaded: false,
  chatVisible: true,
  isShowRightPanel: true,
};

export const layoutModel: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setMobileDevice: produce((state, payload: boolean) => {
      state.isMobileDevice = payload;
    }),
    setTabletDevice: produce((state, payload: boolean) => {
      state.isTabletDevice = payload;
    }),
    setOrientationAngle: produce((state, payload: string) => {
      state.orientationAngle = payload;
    }),
    setLoading: produce((state, payload: boolean) => {
      state.loading = payload;
    }),
    setLocale: produce((state, payload: any) => {
      state.locale = payload;
    }),
    setFullScreen: produce((state, payload: boolean) => {
      state.isFullscreen = payload;
    }),
    setLoadingLogo: produce((state, payload: StoreImageTypes) => {
      state.loadingLogo = payload;
    }),
    setActivityWindow: produce((state, payload: boolean) => {
      state.isActivityWindow = payload;
    }),
    setChatScriptLoaded: produce((state, payload: boolean) => {
      state.chatScriptLoaded = payload;
    }),
    setChatVisible: produce((state, payload: boolean) => {
      state.chatVisible = payload;
    }),
    setShowRightPanel: produce((state, payload: boolean) => {
      state.isShowRightPanel = payload;
    }),
  },
});

export default layoutModel;
